const getToken = () =>  {
  const ldata = localStorage.getItem("jwt-token");
  const token = ldata && JSON.parse(ldata)?.data?.token;

  return token;
}

export default getToken